// extracted by mini-css-extract-plugin
module.exports = {"container":"Upload2_container_QKqq7","dropArea":"Upload2_dropArea_1DjyZ","result":"Upload2_result_2zXfB","resultTable":"Upload2_resultTable_2LT80"};